import { normalizePrimitiveWithResetSnapshot } from './primitiveResetSnapshot';

const DEFAULT_IMAGE_LAYER_WIDTH = 140;
const DEFAULT_IMAGE_LAYER_HEIGHT = 140;

const withFiniteNumber = (value, fallback) => (
  Number.isFinite(value) ? Number(value) : Number(fallback)
);

const normalizeLayerName = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed || null;
};

export const isImagePrimitive = (shape) => (
  shape?.layerKind === 'image' || shape?.type === 'image'
);

export const getImagePrimitiveEntries = (shapePrimitives) => {
  const source = Array.isArray(shapePrimitives) ? shapePrimitives : [];
  const entries = [];
  source.forEach((shape, index) => {
    if (!isImagePrimitive(shape)) return;
    const defaultLabel = `Image ${entries.length + 1}`;
    entries.push({
      primitiveId: shape?.id || `shape-${index}`,
      primitive: shape,
      index,
      defaultLabel,
      label: normalizeLayerName(shape?.layerName) || defaultLabel,
    });
  });
  return entries;
};

export const buildImageReplacementPatch = (existingPrimitive, { imageData, imageCropMode } = {}) => {
  const normalizedPrimitive = normalizePrimitiveWithResetSnapshot({
    ...(existingPrimitive || {}),
    type: existingPrimitive?.type || 'image',
    layerKind: existingPrimitive?.layerKind || 'image',
    fill: false,
    stroke: false,
  });
  const preservedCropMode = normalizedPrimitive?.imageCropMode || imageCropMode || 'original';
  const preservedCornerRadius = Number.isFinite(normalizedPrimitive?.cornerRadius)
    ? Number(normalizedPrimitive.cornerRadius)
    : (preservedCropMode === 'circle' ? 999 : 0);
  const preservedX = withFiniteNumber(normalizedPrimitive?.x, 0);
  const preservedY = withFiniteNumber(normalizedPrimitive?.y, 0);
  const preservedWidth = withFiniteNumber(normalizedPrimitive?.width, DEFAULT_IMAGE_LAYER_WIDTH);
  const preservedHeight = withFiniteNumber(normalizedPrimitive?.height, DEFAULT_IMAGE_LAYER_HEIGHT);
  const preservedRotation = withFiniteNumber(normalizedPrimitive?.rotation, 0);

  return {
    imageData,
    imageCropMode: preservedCropMode,
    cornerRadius: preservedCornerRadius,
    x: preservedX,
    y: preservedY,
    width: preservedWidth,
    height: preservedHeight,
    rotation: preservedRotation,
    resetSnapshot: normalizedPrimitive?.resetSnapshot || null,
    resetX: withFiniteNumber(normalizedPrimitive?.resetX, preservedX),
    resetY: withFiniteNumber(normalizedPrimitive?.resetY, preservedY),
    resetWidth: withFiniteNumber(normalizedPrimitive?.resetWidth, preservedWidth),
    resetHeight: withFiniteNumber(normalizedPrimitive?.resetHeight, preservedHeight),
    resetRotation: withFiniteNumber(normalizedPrimitive?.resetRotation, preservedRotation),
    resetStrokeWidth: withFiniteNumber(normalizedPrimitive?.resetStrokeWidth, withFiniteNumber(normalizedPrimitive?.strokeWidth, 3)),
    resetCornerRadius: withFiniteNumber(normalizedPrimitive?.resetCornerRadius, preservedCornerRadius),
    resetSkewX: withFiniteNumber(normalizedPrimitive?.resetSkewX, 0),
  };
};
